var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Active'),"hide-details":"auto"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }